<template>
	<!-- <div class="con">
		<img class="inpPay" src="../assets/inpPay.jpg" />
		<div class="radioDiv">
			<van-radio-group v-model="radioIndex" class="radiosp" @change="onRdio">
			  <van-radio name="1">押金缴纳</van-radio>
			  <van-radio name="2">出院结算</van-radio>
			</van-radio-group>
		</div>
		<div class="pay">
			<div class="pay-text">押金缴费：</div>
			<input type="number" v-model.trim="payMoney" placeholder="住院押金" oninput="if(value.length > 8)value=value.slice(0,8)" />
		</div>
		<div class="queryBtn" @click="inPaycost">缴费</div>
	</div> -->
	<div class="con">
		<div class="pay-title">
			<div>押金</div>
			<div>
				<div @click="showPopup">{{currentDate.getFullYear()}}</div>
				<van-popup v-model="show" position="top" custom-style="height: 20%;">
					<van-datetime-picker :max-date="maxDate" type="year" v-model="currentDate" @cancel="onClose()" @confirm="confirmFn(currentDate)" />
				</van-popup>
			</div>
		</div>
		<div class="list">
			<div v-for="(item, index) in list">
				<div class="list-con">
					<div class="list-con-top" @click="showBtn(index)">
						<div>
							<div>{{item.KSMC}}</div>
							<div class="serial-number">住院序号：{{item.ZYH}}</div>
							<div class="time-disp">
								<van-icon name="underway-o" color="#27BEC4" />
								<div class="time-text">{{item.FYRQ}}</div>
							</div>

						</div>
						<div class="price">
							<div><span>￥</span>{{item.deposiNum}}</div>
							<van-icon name="arrow" color="#ccc" v-if="!item.showState" />
							<van-icon name="arrow-down" color="#ccc" v-else />
						</div>
					</div>
					<div class="paybtn-disp">
						<div></div>
						<div class="paybtn" @click="paycostBtn(item.total, item.ZYH, item.deposiNum, item.deposiArr)">押金缴纳</div>
					</div>
					<div class="deposit-list">
						<div v-for="(dep, depIndex) in item.deposit[0]" class="deposit" v-if="depIndex < depositShowNum" :key="depIndex">押金：￥{{dep.jkje}}</div>
						<div class="depost-more-text" v-if="item.deposit[0].length > 3" @click="depostShowBtn">更多押金</div>
					</div>
				</div>

				<div class="show-box" v-show="item.showState">
					<div v-for="(d, i) in item.d" @click="showBtnClass(index, i)">
						<div class="show-disp">
							<div style="font-size: 14px;">{{d.SFMC}}</div>
							<div style="display: flex;">
								<div class="show-price"><span>￥</span>{{d.detailTotal}}</div>
								<van-icon name="arrow" color="#ccc" v-if="!d.showStateClass" />
								<van-icon name="arrow-down" color="#ccc" v-else />
							</div>
						</div>
						<div class="show-disp" v-for="(data, deIndex) in d.detail" v-show="d.showStateClass">
							<div class="medicines">
								<div>{{data.FYMC}}</div>
								<div>医生：{{data.YGXM}}</div>
								<div class="time-disp">
									<van-icon name="underway-o" color="#27BEC4" />
									<div class="time-text">{{data.FYRQ}}</div>
								</div>
							</div>
							<div class="show-disp-right">
								<div class="box-num">x{{data.FYSL}}</div>
								<div class="box-unit-price"><span>￥</span>{{data.ZJJE}}</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="noImg" v-if="noImgShow == true">
				<img src="../assets/404.gif" />
				<div class="no-text">无缴费清单~~</div>
			</div>
		</div>
		<div class="backgroundC" v-show="depositBox"></div>
		<div class="depositBox" v-show="depositBox">
			<div>押金缴纳</div>
			<div class="deposit-input"><input v-model="depositMoney" placeholder="输入要缴纳的住院押金" type="number"></div>
			<div class="deposit-bottom">
				<div class="cancel-btn" @click="cancelBtn()">取消</div>
				<div class="confirm-btn" :class="[depositTime != null ? 'confirm-btn-ccc': '']" @click="confirmBtn()">确定</div>
			</div>
		</div>
	</div>
</template>

<script>
	import $ from 'jquery'
	export default {
		name: 'inpatientRecords',
		data() {
			return {
				msg: '押金缴纳',
				cardUserInfo: JSON.parse(localStorage.getItem('cardUserInfo')),
				userInfo: JSON.parse(localStorage.getItem('userInfo')),
				radioIndex: '',
				payMoney: '',
				noImgShow: false,
				timer: null,
				show: false,
				currentDate: new Date(),
				maxDate: new Date(),
				list: [],
				depositBox: false,
				depositZYH: '', //押金住院号
				depositMoney: '',
				depositTime: null,
				total: '', //总金额
				depositShowNum: 3,
			}
		},
		methods: {
			//更多押金
			depostShowBtn(){
				if(this.depositShowNum == 3){
					this.depositShowNum = 100;
				}else{
					this.depositShowNum = 3;
				}
			},
			//押金确定按钮
			confirmBtn() {
				let that = this;
				clearTimeout(this.depositTime)

				this.depositTime = setTimeout(function() {
					let money = Number(that.depositMoney);
					if (money <= 0 || money == null || money == '') {
						that.$toast('请输入缴纳押金')
						return false;
					}
					that.$toast('请稍等！');
					that.$Axios.Post( that.$Axios.wxUrl + '/wxpay/payOrder?brid=' + that.cardUserInfo.brid + '&ghxh=undefiend' + '&sfzh=' + that.cardUserInfo
						.sfzh + '&name=' + that.cardUserInfo.name + '&zyh=' + that.depositZYH + '&status=' + 1 + '&zjje=' + that.total +
						'&payType=2' + '&year=' + that.currentDate.getFullYear() + '&wxje=' + money + '&openid=' + that.cardUserInfo.wechatId,
						null).then(res => {
						console.log(res)
						if (res.data.code == 0) {
							that.depositBox = false;
							that.depositMoney = '';
							const pay_params = res.data.data;
							if (typeof WeixinJSBridge === "undefined") {
								that.$toast('请在手机操作！');
								if (document.addEventListener) {
									document.addEventListener('WeixinJSBridgeReady', that.onBridgeReady, false);
								} else if (document.attachEvent) {
									document.attachEvent('WeixinJSBridgeReady', that.onBridgeReady);
									document.attachEvent('onWeixinJSBridgeReady', that.onBridgeReady);
								}
							} else {
								that.onBridgeReady(pay_params);
							}
						} else {
							that.$toast(res.data.msg)
							that.$toast('缴纳押金失败')
							that.depositBox = false;
						}
					})
					
				}, 300)
			},
			//押金取消按钮
			cancelBtn() {
				this.depositMoney = '';
				this.depositBox = false;
			},
			showPopup() {
				this.show = true;
			},

			onClose() {
				this.show = false;
			},
			confirmFn(e) {
				this.currentDate = e;
				this.show = false;
				this.GetMoneyByYzxh()
			},
			depositBtn(e, i, index, statue, jkxh) {
				let dataList = this.list;
				let that = this;
				let depositList = dataList[index].deposiArr;
				console.log(depositList)
				if (!statue) { //false 是打钩状态
					if (Number(dataList[index].deposiNum) - e < 0) {
						this.$toast('押金超过所需缴费')
						return false;
					} else {
						dataList[index].deposiNum = (Number(dataList[index].deposiNum) - e).toFixed(2)
						dataList[index].deposit[0][i].flag = true;
						depositList.push({
							jkje: e,
							jkxh: jkxh
						})
					}
				} else {
					dataList[index].deposiNum = (Number(dataList[index].deposiNum) + e).toFixed(2)
					dataList[index].deposit[0][i].flag = false;
					console.log(depositList)
					depositList.map((v, i) => {
						if (v.jkxh == jkxh) {
							depositList.splice(i, 1)
						}
					})

				}
				dataList[index].deposiArr = depositList
				this.list = dataList

			},

			/**
			 * 未支付列表
			 * type：1-未缴费 2-已缴费
			 * year：yyyy
			 * */
			GetMoneyByYzxh() {

				this.$Axios.Get('/inpatient/getInFy?sfzh=' + this.cardUserInfo.sfzh + '&name=' + this.cardUserInfo.name +
					'&type=1&year=' +
					this.currentDate
					.getFullYear(),
					null).then(res => {
					console.log(res)
					if (res.code == 0) {
						let dataList = res.msg;
						let tbkkListMap = res.tbkkList;
						if (dataList.length > 0) {
							this.noImgShow = false;

							let newArr = JSON.parse(JSON.stringify(dataList));
							let newClassified = JSON.parse(JSON.stringify(dataList));

							//根据住院号ZHY分总
							for (let i = 0; i < newArr.length; i++) {
								newArr[i].showState = false;
								let total = 0;
								for (let j = i + 1; j < newArr.length;) {

									if (newArr[i].ZYH == newArr[j].ZYH) {
										total += Number(newArr[j].ZJJE);
										newArr.splice(j, 1)
									} else {
										j++;

									}
								}
								total += Number(newArr[i].ZJJE);
								newArr[i].total = total.toFixed(2);
								newArr[i].deposiNum = total.toFixed(2);
								newArr[i].deposiArr = []
							}
							//住院号一样，分药类型SFMC
							for (let k = 0; k < newArr.length; k++) {
								for (let i = 0; i < newClassified.length; i++) {
									newClassified[i].showStateClass = false;
									if (newArr[k].ZYH == newClassified[i].ZYH) {
										for (let j = i + 1; j < newClassified.length;) {
											if (newClassified[i].SFMC == newClassified[j].SFMC) {
												newClassified.splice(j, 1)
											} else {
												j++;
											}
										}
									}
								}
							}

							for (let k = 0; k < newClassified.length; k++) {
								let s = [];
								let n = 0;
								for (let j = 0; j < dataList.length; j++) {
									if (newClassified[k].SFMC == dataList[j].SFMC) {
										n += Number(dataList[j].ZJJE);
										s.push(dataList[j])
									}
								}
								newClassified[k].detail = s;
								newClassified[k].detailTotal = n.toFixed(2);
							}

							for (let k = 0; k < newArr.length; k++) {
								newArr[k].d = newClassified;

							}

							newArr.map((value, index) => {
								let deposit = [];
								Object.keys(tbkkListMap).forEach(key => {
									tbkkListMap[key].map((v) => {
										v.flag = false;
									})
									if (value.ZYH == key) {
										deposit.push(tbkkListMap[key])
									}
								})
								value.deposit = deposit
							})
							console.log(newArr)
							this.list = newArr;
						} else {
							this.list = []
							this.noImgShow = true;
						}

					} else {
						this.noImgShow = true;
					}
				}).catch(err => {
					console.log(err)
				})
			},
			//显示隐藏详情
			showBtn(e) {
				let listData = this.list;

				listData[e].showState = !listData[e].showState;
				this.list = listData;
			},
			showBtnClass(index, i) {
				let listData = this.list;

				listData[index].d[i].showStateClass = !listData[index].d[i].showStateClass;
				this.list = listData;
			},
			//缴费
			paycostBtn(e, zyh, deposiNum, deposiArr) {
				this.total = e;
				this.depositZYH = zyh;
				this.depositMoney = '';
				this.depositBox = true;
			},
			onBridgeReady(params) {
				var that = this
				WeixinJSBridge.invoke(
					'getBrandWCPayRequest', {
						"appId": params.appId, //公众号名称，由商户传入
						"timeStamp": params.timeStamp, //支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
						"nonceStr": params.nonceStr, //支付签名随机串，不长于 32 位
						"package": params.package, //统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
						"signType": 'MD5', //签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
						"paySign": params.paySign, //支付签名
					},
					function(res) {
						if (res.err_msg === "get_brand_wcpay_request:ok") {
							this.$toast('支付成功！');
							setTimeout(() => {
								that.$router.go(0)
								// that.$router.push({
								// 	path: '/inpatientDeposit'
								// })
							}, 500)
						} else if (res.err_msg === "get_brand_wcpay_request:fail") {
							this.$toast('支付失败！');
						}
						that.depositTime = null;
					});
			},

			onRdio(event) {
				console.log(event)
				this.radioIndex = event;
			}
		},
		mounted() {
			this.GetMoneyByYzxh();
			console.log(this.cardUserInfo)
		},
		created() {},
	}
</script>

<style scoped>
	.con {
		position: relative;
		display: flex;
		flex-direction: column;
		flex-wrap: nowrap;
		width: 100%;
		height: 100%;
	}

	.pay-title {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 20px 30px;
		background: #27BEC4;
		color: #fff;
		font-size: 15px;
	}

	.inpPay {
		width: 100%;
		height: 100%;
		max-height: 70vh;
	}

	.head {
		font-size: 15px;
		background-color: #fff;
	}

	.radioDiv {
		margin-top: 20px;
	}

	.radiosp {
		padding: 20px 0 0;
		display: flex;
		justify-content: space-around;
		font-size: 18px;
	}

	.pay {
		display: flex;
		align-items: center;
		font-size: 15px;
		margin: 50px 20px 0;
	}

	.pay-text {
		width: 80px;
	}

	.pay input {
		width: 60%;
		padding: 10px;
		border: 1px solid #27BEC4;
		border-radius: 10px;
	}

	.queryBtn {
		padding: 10px 0;
		margin: 50px 20px 0;
		background: #27BEC4;
		text-align: center;
		color: #fff;
		font-size: 18px;
		border-radius: 10px;
	}

	.noImg {
		margin-top: 10vh;
		text-align: center;
	}

	.no-text {
		margin-top: 10px;
		color: #27BEC4;
		font-size: 16px;

	}

	.list {
		flex: 1;
		overflow-y: auto;
	}

	.list-con {
		padding: 10px 20px;
		margin: 10px auto 0;
		font-size: 15px;
		border: 1px solid #ccc;
		border-radius: 10px;
		width: 80%;
		background-color: #fff;
	}

	.list-con-top {
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.time-disp {
		display: flex;
		align-items: center;
		margin-top: 5px;
		color: #999;
	}

	.time-text {
		margin-left: 10px;
	}

	.price {
		display: flex;
		align-items: center;
		color: #FF0000;
		font-size: 18px;
		font-weight: 700;
	}

	.price span {
		font-weight: 500;
		font-size: 12px;
	}

	.show-price {
		display: flex;
		align-items: center;
		color: #FF0000;
		font-size: 14px;
		font-weight: 700;
	}

	.total {
		display: flex;
		font-size: 15px;
	}

	.total div {
		padding: 20px 0;
		width: 50%;
		text-align: center;
	}

	.combined {
		background-color: #fff;
	}

	.combined span {
		color: #FF0000;
		font-size: 18px;
	}

	.pay-btn {
		background-color: #27BEC4;
		color: #fff;
	}

	.paybtn-disp {
		display: flex;
		justify-content: space-between;
	}

	.paybtn {
		display: inline-block;
		margin-top: 5px;
		padding: 5px 10px;
		font-size: 14px;
		color: #fff;
		border-radius: 15px;
		background-color: #27BEC4;
	}

	.show-box {
		padding: 10px;
		margin: 0 auto;
		width: 85%;
		background-color: #fff;
	}

	.show-disp {
		display: flex;
		justify-content: space-between;
		margin: 10px 0;
	}

	.medicines {
		width: 75%;
		color: #666;
		font-size: 14px;
	}

	.box-unit-price {
		font-size: 14px;
		color: #FF0000;
		font-weight: 700;
	}

	.box-unit-price span {
		font-weight: 500;
		font-size: 12px;
	}

	.box-num {
		text-align: end;
	}

	.deposit {
		display: flex;
		align-items: center;
		margin: 10px 0;
		font-size: 14px;
		color: #666;
	}

	.success-null {
		margin-right: 10px;
		width: 15px;
		height: 15px;
		border: 1px solid #999;
		border-radius: 50%;
	}

	.success-img {
		margin-right: 10px;
		width: 20px;
		height: 20px;
	}

	.backgroundC {
		position: absolute;
		left: 0;
		top: 0;
		width: 100%;
		height: 100%;
		background-color: #ccc;
		opacity: 0.5;
		z-index: 5;
	}
	.deposit-list{
		position: relative;
	}
	.depost-more-text{
		position: absolute;
		right: 0;
		bottom: -10px;
		color: #999;
		font-size: 12px;
	}
	.depositBox {
		padding: 20px 10px 10px;
		position: absolute;
		left: 0;
		right: 0;
		top: 0;
		bottom: 0;
		margin: auto;
		width: 80%;
		height: 130px;
		background-color: #fff;
		border-radius: 18px;
		text-align: center;
		color: #000000;
		z-index: 10;
	}

	.deposit-input {
		margin: 20px 0;
	}

	.deposit-input input {
		padding: 4px;
	}

	.deposit-bottom {
		display: flex;
		align-items: center;
		justify-content: space-around;
	}

	.cancel-btn {
		color: #ff0000;
	}
	.confirm-btn-ccc{
		color: #1296DB;
	}
	/*修改提示文字的颜色*/
	input::-webkit-input-placeholder {
		/* WebKit browsers */
		color: #666666;
		font-size: 12px;
	}

	input:-moz-placeholder {
		/* Mozilla Firefox 4 to 18 */
		color: #666666;
		font-size: 12px;
	}

	input::-moz-placeholder {
		/* Mozilla Firefox 19+ */
		color: #666666;
		font-size: 12px;
	}

	input:-ms-input-placeholder {
		/* Internet Explorer 10+ */
		color: #666666;
		font-size: 12px;
	}
</style>
